import React from "react"
import Card from "../../../../../../lib/common/blocks/card/Card"
import Button from "../../../../../../lib/common/blocks/button/Button"
import Image from "../../../../../../lib/common/blocks/image/Image"

const MegaMenuCard = ({ card }) => {
  return (
    <Card
      type="no-shadow"
      className="p-0"
    >
      <figure>
        <picture>
          <Image
            dataSizesPreset={"hero"}
            imgSrc={card?.cardImage?.data?.attributes.url}
            imgAlt={card?.cardImage?.data?.attributes.alternativeText}
            imgWidth={card?.cardImage?.data?.attributes.width}
            imgHeight={card?.cardImage?.data?.attributes.height}
            formats={card?.cardImage?.data?.attributes?.formats}
          />
        </picture>
      </figure>
      <h4 className="mt-2 line-clamp-2">{card?.cardTitle}</h4>
      <p className="mt-1 line-clamp-3">{card?.cardDescription}</p>
      <Button
        aspect={"contrastant"}
        color={"primary"}
        size={"large"}
        className="fluid mt-2"
        ctalink={card?.buttonCtaLink}
      >
        {card?.cardButtonText}
      </Button>
    </Card>
  )
}

export default MegaMenuCard
